import apiSlice from "./apiSlice";
const myWorkApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getMyWork: builder.query({
            query: (req) => ({
                url: `DataAlert/GetMyWork`,
                params: req
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["GetMyWork"],
        }),
        getMyWorkList: builder.query({
            query: (req) => ({
                url: `DataAlert/GetMyWork`,
                params: req
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["GetMyWork"],
        }),
        getMyWorkCount: builder.query({
            query: (req) => ({
                url: `DataAlert/GetMyWorkCount`,
                params: req
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["GetMyWorkCount"],
        }),

    }),
});

export const {
    useLazyGetMyWorkListQuery,
    useGetMyWorkQuery,
    useGetMyWorkCountQuery
} = myWorkApiSlice;
